import React from 'react'

export default function({ text, color, size='md' }) {
  const sizeClass = `components--pill--${size}`
  const colorClass = color
  return (
    <div className={`components--pill ${colorClass} ${sizeClass}`}>
      {text}
    </div>
  )
}
